import { getSelectedLocationName } from '@Composables/LocationHelpers';
import { FilterModel, FilterParamEntry } from '@Apps/Search/Src/Models/FilterModel';
import searchBarTranslations from '@Components/SearchBar/Translations/VueTranslations';
import { displayShortDateNoWeekday } from '@Functions/DateFunctions';
import * as searchComposables from '@Composables/SearchComposables';
import LocationFilterSetting from '../Types/search/LocationFilterSetting';
import { FilterSelectionCompanions, FilterSelectionDate, FilterSelectionLocation } from '../Types/FilterSelections';



export const getActiveFilterCount = (filter: FilterModel) => {


    // will count all active filters, including non-default values for guest pickers etc.
    // note that a location filter will count as "1", as does a date-range filter.


    let count = 0;


    // a provider does not have a visible filter currently, but you should be able to clear it.
    if (searchComposables.getSearchMetaDefinitions().providerPageId) {

        count++;
    }



    if (getLocationSelectionDisplay(filter).hasSelection) {
        count++;
    }

    if (filter.date && filter.date.arrival && filter.date.departure) {
        count++;
    }

    // non default guests:
    if (filter.companions.numberOfAdults != 2 || filter.companions.numberOfPets != 0 || filter.companions.numberOfBabies != 0) {

        count++;
    }

    if (filter.accommodationTypes.length) {
        count++;
    }

    if (filter.bathrooms != 1) {
        count++;
    }

    if (filter.bedrooms != 1) {

        count++;
    }

    count += filter.criteria.reduce((count, criteriaArray) => count + criteriaArray.length, 0);


    if (count == 0 && searchComposables.getSearchMetaDefinitions().landingPageId) {

        // if none of the filters trigger, then in this case there is still a filter active, because it is a landing page.
        // this could happen with the 'hidden' filters that can be matched as hasAnySearch, which are not loaded in the front-end currently.
        // if we need to know "what" these are, we are going to have to do some more changing..
        // for now we just add to the count to let the 'clear filters' button become active
        count++;
    }

    return count;
}

export const getDatesSelectionDisplay = (filter: FilterModel) => {

    return getDatesSelectionDisplayLf(filter.date);
}


export const getDatesSelectionDisplayLf = (filter: FilterSelectionDate) => {


    let result = {

        hasSelection: false,
        displayValue: searchBarTranslations.searchBar__When,
    };

    if (!filter || !filter.arrival || !filter.departure) {

        // no results, no Selection.
        return result;
    }

    result.hasSelection = true;
    result.displayValue = displayShortDateNoWeekday(filter.arrival) + " - " + displayShortDateNoWeekday(filter.departure);

    return result;
};


export const getLocationSelectionDisplay = (filter: FilterModel) => {

    return getLocationSelectionDisplayLf(filter.location);
}

// display name in filter
export const getLocationSelectionDisplayLf = (filterLocation: FilterSelectionLocation) => {

    let result = {

        hasSelection: false,
        hasNoPreferenceSelection: false,
        hasMultipleSelections: false,
        displayValue: searchBarTranslations.searchBar__Where,
    };

    if (!filterLocation.selection || filterLocation.selection.length == 0) {

        // no results, no Selection.
        //unless it is a predefined filter based on the landing page/providerpage =>  accommodation selection

        if (searchComposables.getSearchMetaDefinitions()?.locationFilterSetting == LocationFilterSetting.Prevent) {

            result.displayValue = searchComposables.getSearchMetaDefinitions().contentTitle;
            result.hasSelection = true;
        }


        return result;
    }

    result.hasNoPreferenceSelection = filterLocation.selection.length > 0 && filterLocation.selection[0] && filterLocation.selection[0].countryNoPreference;

    if (result.hasNoPreferenceSelection) {

        result.displayValue = searchBarTranslations.searchBar_Btn_AllCountries;
        return result;
    }

    if (filterLocation.selection.length == 1) {

        result.hasSelection = true;
        var first = getSelectedLocationName(filterLocation.selection[0]);

        if (first.cityName) {
            result.displayValue = first.cityName;

            if (first.regionName) {
                result.displayValue += ` (${first.regionName})`
            }

            else {
                result.displayValue += ` (${first.countryName})`
            }
        }

        else if (first.regionName) {

            result.displayValue = `${first.regionName} (${first.countryName})`;

        } else if (first.countryName) {

            result.displayValue = first.countryName;
        }

    }
    else {
        result.hasSelection = true;
        result.hasMultipleSelections = true;
        result.displayValue = searchBarTranslations.searchBar_Text_MultipleLocations;
    }

    return result;



};


export const getGuestsSelectionDisplay = (filter: FilterModel, hasBeenActive: boolean) => {

    return getGuestsSelectionDisplayLf(filter.companions, hasBeenActive);
}

export const getGuestsSelectionDisplayLf = (filter: FilterSelectionCompanions, hasBeenActive: boolean) => {

    let result = {

        hasBeenActive: hasBeenActive,
        hasSelection: false,
        displayValue: searchBarTranslations.searchBar__Who,
    };

    if (!hasBeenActive) {

        // do not show any results 

    }


    else {

        result.hasSelection = true;
        const displayValues = [];
        if (filter.numberOfAdults == 1) {

            displayValues.push(filter.numberOfAdults + " " + searchBarTranslations.searchBar__Guest);
        }
        if (filter.numberOfAdults > 1) {

            displayValues.push(filter.numberOfAdults + " " + searchBarTranslations.searchBar__Guests);
        }
        if (filter.numberOfBabies == 1) {

            displayValues.push(filter.numberOfBabies + " " + searchBarTranslations.searchBar__Baby);
        }
        if (filter.numberOfBabies > 1) {

            displayValues.push(filter.numberOfBabies + " " + searchBarTranslations.searchBar__Babies);
        }
        if (filter.numberOfPets == 1) {

            displayValues.push(filter.numberOfPets + " " + searchBarTranslations.searchBar__Pet);
        }
        if (filter.numberOfPets > 1) {

            displayValues.push(filter.numberOfPets + " " + searchBarTranslations.searchBar__Pets);

        }

        result.displayValue = displayValues.join(", ");

    }



    return result;



};




